var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 253,
    height: 29,
    viewBox: "0 0 253 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31_207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76.6822 24.6661C78.0182 24.6661 79.2708 24.1309 79.8553 22.9195L85.5615 10.947C85.6172 10.8061 85.7842 10.7216 85.9234 10.7216C86.1461 10.7216 86.3688 10.8906 86.3688 11.2287V24.2717H91.212V10.3273C91.212 8.18627 90.5718 6.86224 89.4584 5.96078C88.6234 5.28468 87.5099 4.80579 86.1738 4.80579C83.7801 4.80579 82.3883 6.24248 81.4141 8.35529L77.1553 17.7079C77.044 17.9896 76.9049 18.0741 76.6822 18.0741C76.4595 18.0741 76.3202 17.9896 76.209 17.7079L71.9502 8.35529C70.9759 6.24248 69.5842 4.80579 67.1904 4.80579C65.8543 4.80579 64.7409 5.28468 63.9059 5.96078C62.7925 6.86224 62.1523 8.18627 62.1523 10.3273V24.2717H66.9956V11.2287C66.9956 10.8906 67.2182 10.7216 67.4409 10.7216C67.5802 10.7216 67.7471 10.8061 67.8028 10.947L73.509 22.9195C74.0935 24.1309 75.3461 24.6661 76.6822 24.6661Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.5756 5.22833C94.7942 5.22833 93.9034 6.07345 93.9034 7.79186V21.6236C93.9034 23.3984 94.7942 24.2717 96.5478 24.2717H113.694V19.3981H99.3868C99.0807 19.3981 98.9418 19.2292 98.9418 18.8911V16.5811H113.61V12.919H98.9418V10.7498C98.9418 10.4399 99.0807 10.2708 99.3868 10.2708H113.694V5.22833H96.5756Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.223 5.22833V10.2708H123.49V24.2717H128.556V10.2708H136.795V5.22833H115.223Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.659 8.32712C150.602 5.96078 148.848 4.80579 146.231 4.80579C143.531 4.80579 141.834 5.96078 140.775 8.32712L134.04 23.4266C133.9 23.7365 133.817 23.99 133.734 24.2717H139.551C139.579 24.0464 139.662 23.821 139.746 23.5956L140.721 21.3138H151.854L152.856 23.6238C152.939 23.821 153.023 24.0181 153.079 24.2717H158.757C158.674 23.99 158.59 23.7365 158.451 23.4266L151.659 8.32712ZM142.557 17.1163L145.425 10.2991C145.619 9.84833 145.925 9.70748 146.26 9.70748C146.622 9.70748 146.955 9.8765 147.122 10.2991L150.017 17.1163H142.557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.971 5.22833C161.164 5.22833 160.746 5.62272 160.746 6.4115V24.2717H165.784V19.4827H174.441C177.336 19.4827 179.256 18.4685 180.537 16.9192C181.566 15.6515 182.179 14.0457 182.179 12.3555C182.179 10.4399 181.4 8.60881 180.092 7.28479C178.839 6.01711 177.113 5.22833 174.441 5.22833H161.971ZM165.784 14.8063V10.6653C165.784 10.3836 165.924 10.2708 166.146 10.2708H174.552C175.638 10.2708 176.279 10.609 176.695 11.116C177.002 11.5104 177.168 11.9893 177.168 12.5527C177.168 13.0879 177.002 13.5386 176.724 13.9049C176.306 14.4683 175.665 14.8063 174.552 14.8063H165.784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.979 8.32712C196.92 5.96078 195.167 4.80579 192.551 4.80579C189.851 4.80579 188.153 5.96078 187.095 8.32712L180.359 23.4266C180.22 23.7365 180.137 23.99 180.052 24.2717H185.87C185.898 24.0464 185.982 23.821 186.065 23.5956L187.039 21.3138H198.173L199.176 23.6238C199.259 23.821 199.342 24.0181 199.398 24.2717H205.077C204.993 23.99 204.909 23.7365 204.771 23.4266L197.979 8.32712ZM188.877 17.1163L191.743 10.2991C191.939 9.84833 192.245 9.70748 192.578 9.70748C192.94 9.70748 193.275 9.8765 193.441 10.2991L196.337 17.1163H188.877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.103 17.5108H220.872C222.347 17.5108 222.931 17.9896 222.931 19.201V23.004C222.931 23.4266 222.959 23.8492 223.015 24.2717H228.109C228.053 23.7364 228.025 23.2857 228.025 22.4688V18.6657C228.025 16.4966 227.468 15.4824 226.215 14.7218C227.551 13.7359 227.997 12.2992 227.997 10.7779C227.997 9.34124 227.413 8.01722 226.494 7.03125C225.464 5.9326 223.989 5.22833 221.679 5.22833H208.318C207.483 5.22833 207.065 5.62272 207.065 6.4115V24.2717H212.103V17.5108ZM212.103 13.1724V10.4117C212.103 10.1582 212.242 9.98916 212.521 9.98916H221.011C221.65 9.98916 222.096 10.1863 222.374 10.4962C222.653 10.7779 222.792 11.1723 222.792 11.5667C222.792 11.933 222.653 12.271 222.43 12.5527C222.124 12.919 221.706 13.1724 221.011 13.1724H212.103Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.497 5.22833V24.2717H235.59V15.8486L244.609 23.4829C244.943 23.7647 245.221 24.0181 245.444 24.2717H252.96C252.737 24.0181 252.487 23.7928 252.236 23.5674L241.129 14.4683C240.991 14.3556 240.962 14.2993 240.962 14.1584C240.962 14.0176 241.018 13.9331 241.129 13.8485L251.484 5.73541C251.651 5.59455 251.874 5.39735 251.985 5.22833H244.943C244.748 5.48187 244.442 5.79174 244.164 6.01711L235.59 13.0316V5.22833H230.497Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7893 0.458836C16.6506 -0.0443845 17.7116 -0.0443838 18.5728 0.458837L29.0763 6.59614C29.394 6.78181 29.805 6.78182 30.1228 6.59616L40.6263 0.458852C41.4874 -0.0443676 42.5485 -0.0443669 43.4097 0.458853L53.9132 6.59616C54.7744 7.09937 55.3049 8.02936 55.3049 9.03581V21.3105C55.3049 22.3168 54.7744 23.2468 53.9132 23.7501L52.7487 24.4305C52.6763 24.4728 52.5856 24.417 52.5856 24.3323V12.5705C52.5856 11.264 51.9149 10.0514 50.8144 9.36845L43.9041 5.07978C42.7421 4.35863 41.2831 4.34016 40.1035 5.03166L32.6828 9.38248C31.5371 10.0542 30.8318 11.2926 30.8318 12.6326V23.3358C30.8318 23.704 30.4379 23.9342 30.1228 23.7501C29.805 23.5644 29.394 23.5643 29.0763 23.75L28.7139 23.9618C28.5605 24.0515 28.3672 23.9251 28.3672 23.7458V12.6929C28.3672 11.3757 27.6855 10.1548 26.5705 9.47525L19.1228 4.93614C17.9307 4.2096 16.4372 4.21903 15.2541 4.96056L8.06145 9.46887C6.96896 10.1537 6.30422 11.3616 6.30422 12.6621V23.7768C6.30422 24.0165 6.04433 24.1932 5.83926 24.0734L5.28591 23.75C4.42469 23.2468 3.89417 22.3168 3.89417 21.3104V9.03579C3.89417 8.02935 4.42469 7.09936 5.28591 6.59614L15.7893 0.458836Z",
    fill: "url(#paint0_linear_31_207)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.1865 3.64862L28.6101 10.2729V23.4343L18.8992 28.5468C17.8257 29.1119 16.5473 29.1119 15.4738 28.5467L5.76306 23.4343V10.2729L17.1865 3.64862Z",
    fill: "url(#paint1_linear_31_207)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M42.0777 3.64862L53.6214 10.3189V23.5716L43.7455 28.5993C42.6962 29.1335 41.4591 29.1335 40.4098 28.5993L30.5339 23.5716V10.3189L42.0777 3.64862Z",
    fill: "url(#paint2_linear_31_207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9288 19.6331C45.0305 17.3065 56.7801 11.6791 56.1723 7.06397C56.1106 6.59559 55.924 6.15564 55.6227 5.74561C56.4943 6.3883 57.0228 7.13044 57.1507 7.96428C57.8681 12.6463 45.6772 18.4464 29.9216 20.9192C14.166 23.392 0.811977 21.601 0.0945612 16.9191C-0.113448 15.5615 0.763699 14.11 2.49827 12.6729C1.72536 13.6291 1.36429 14.579 1.48421 15.4895C2.09201 20.1045 14.8271 21.9597 29.9288 19.6331Z",
    fill: "url(#paint3_linear_31_207)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_31_207",
    x1: 3.90731,
    y1: 7.63313,
    x2: 56.7058,
    y2: 26.2205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.474158,
    stopColor: "#EEA923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1BFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_31_207",
    x1: 5.70892,
    y1: 16.287,
    x2: 28.6641,
    y2: 16.287,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0ACFF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104621,
    stopColor: "#1ECCE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225809,
    stopColor: "#33C8CF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364309,
    stopColor: "#4AC4BA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499347,
    stopColor: "#09A278"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644772,
    stopColor: "#85BA83"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783273,
    stopColor: "#A7B464"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897535,
    stopColor: "#BCB150"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E0AB2F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_31_207",
    x1: 30.4792,
    y1: 16.3747,
    x2: 53.6761,
    y2: 16.3747,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EBA925"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104621,
    stopColor: "#EBA32A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.225809,
    stopColor: "#E59B38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.364309,
    stopColor: "#DE8E4B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.499347,
    stopColor: "#BE5928"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.644772,
    stopColor: "#CC7079"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.783273,
    stopColor: "#C15D97"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.897535,
    stopColor: "#BA51A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B143C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_31_207",
    x1: 24.4611,
    y1: 17.9945,
    x2: 63.6849,
    y2: 4.51405,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31_207"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 253,
    height: 29,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a6d7ff1c4ed092959ac475230a001d43.svg";
export { ForwardRef as ReactComponent };